import { SelectedItemDetailEntry } from '@common/models';

import { DetailDataRecord } from '../models/DetailDataRecord';

const blankDetailEntry: SelectedItemDetailEntry = {
    quantity: 0,
    note: '',
};

export const detailEntryToDataRecord = (detailEntry: SelectedItemDetailEntry, key: string): DetailDataRecord => {
    return { ...detailEntry, key };
};

export const addDataRecords = (original: DetailDataRecord[], howMany = 1): DetailDataRecord[] => {
    const results = [...original];
    for (let i = 0; i < howMany; i++) {
        results.push(detailEntryToDataRecord(blankDetailEntry, results.length.toString()));
    }
    return results;
};
export const deleteDataRecord = (original: DetailDataRecord[], key: string): DetailDataRecord[] => {
    return original
        .filter((item) => item.key !== key)
        .map((item, index) => {
            return detailEntryToDataRecord(item, index.toString());
        });
};

export const dataRecordToDetailEntry = (dataRecord: DetailDataRecord): SelectedItemDetailEntry => {
    return { quantity: dataRecord.quantity, note: dataRecord.note };
};
